// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgMeetingUnknow16 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 16 16"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<circle cx={8} cy={8} r={7.5} stroke="#AFB3BA" />
				<path d="M8.76515 9.83655H7.47395C7.47048 9.64988 7.46874 9.53752 7.46874 9.49603C7.46874 9.07773 7.53789 8.73377 7.67618 8.4641C7.81447 8.19272 8.09275 7.89024 8.50759 7.55146C8.92243 7.2144 9.17134 6.99315 9.25084 6.8877C9.37702 6.72351 9.43925 6.54027 9.43925 6.34151C9.43925 6.06493 9.32863 5.82813 9.10737 5.62937C8.88612 5.43231 8.58882 5.3338 8.21375 5.3338C7.85248 5.3338 7.55 5.43748 7.30629 5.64318C7.06428 5.84888 6.89662 6.16348 6.80502 6.58522L5.5 6.42274C5.53628 5.81778 5.79384 5.3044 6.27091 4.88265C6.74969 4.4609 7.3754 4.25 8.15325 4.25C8.96911 4.25 9.61902 4.46434 10.103 4.89129C10.5853 5.31822 10.8272 5.81431 10.8272 6.38299C10.8272 6.69585 10.7374 6.99315 10.5611 7.27317C10.383 7.55319 10.0045 7.93519 9.4237 8.41744C9.12293 8.66806 8.93625 8.86859 8.86366 9.02069C8.79108 9.1728 8.75821 9.44418 8.76515 9.83655ZM7.47395 11.75V10.3274H8.8965V11.75H7.47395Z" />
			</Svg>
		);
	}
);
SvgMeetingUnknow16.defaultProps = {
	size: 16,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgMeetingUnknow16;
